// Section 19 and 14 (stream E2), 24.14 actions: answers to open event prompts (the arrival screen
// included) go into the draft's `eventChoices` ({ kind: 'event', choiceId, personIds }) and are
// applied by the event-choices phase at the start of the next season. The migration policy
// (Section 18) is a draft policy change. Allowed only while deciding (24.7).
import type { MigrationOption, PromptAnswer, PromptId } from '../../sim/api';
import { withBoundary } from '../boundary';
import { requireGame } from '../guards';
import { editDraft } from './decision';

/** Answer an open event prompt; the choice must be one the prompt offers. */
export const answerEvent = withBoundary((promptId: PromptId, answer: PromptAnswer): void => {
  const state = requireGame();
  const prompt = state.openPrompts.find((p) => p.id === promptId);
  if (prompt?.kind !== 'event' || answer.kind !== 'event') return;
  if (!prompt.choices.some((c) => c.id === answer.choiceId)) return;
  const personIds = answer.personIds.filter((id) => prompt.subjectIds.includes(id)).sort();
  editDraft((d) => ({
    ...d,
    eventChoices: { ...d.eventChoices, [promptId]: { ...answer, personIds } },
  }));
});

/** Section 18 migration policy: the default at the gate so the arrival prompt can be skipped. */
export const setMigrationPolicy = withBoundary((option: MigrationOption): void => {
  const state = requireGame();
  editDraft((d) => {
    const policies = { ...d.policies };
    if (state.policies.migration === option) delete policies.migration;
    else policies.migration = option;
    return { ...d, policies };
  });
});
